import { createSlice } from '../factory/slice-factory';
import { getReviewerInfo } from '@repo/api';
import { runWithDedup } from '../utils';
const initialState = {
    data: null,
    loading: false,
    error: null,
};
export const reviewerSlice = createSlice({
    name: 'reviewer',
    initialState,
    persist: { keys: [] },
    actions: ({ setSlice, get }) => ({
        /**
         * Fetch reviewer info from API
         */
        fetchReviewerInfo: async () => {
            const key = 'reviewer.fetchReviewerInfo';
            setSlice({ loading: true, error: null });
            try {
                // Use deduplication to prevent multiple simultaneous calls
                const data = await runWithDedup(key, () => getReviewerInfo());
                setSlice({
                    data: data,
                    loading: false,
                    error: null,
                });
                // Sync isBlurRequired in profile slice
                const state = get();
                state?.profile?.syncIsBlurRequired?.();
            }
            catch (error) {
                console.error('Error fetching reviewer info:', error);
                setSlice({
                    loading: false,
                    error: error.message || 'Failed to fetch reviewer info',
                });
                // Sync isBlurRequired even on error (to clear blur if needed)
                const state = get();
                state?.profile?.syncIsBlurRequired?.();
            }
        },
        /**
         * Clear reviewer info (e.g., on logout)
         */
        clearReviewerInfo: () => {
            setSlice({
                data: null,
                loading: false,
                error: null,
            });
            // Sync isBlurRequired in profile slice
            const state = get();
            state?.profile?.syncIsBlurRequired?.();
        },
        /**
         * Manually set reviewer info
         */
        setReviewerInfo: (data) => {
            setSlice({
                data,
                loading: false,
                error: null,
            });
            // Sync isBlurRequired in profile slice
            const state = get();
            state?.profile?.syncIsBlurRequired?.();
        },
    }),
});
